import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {LeadDataAPI, LeadFilterDataAPI} from "./../../../API/Publisher/LeadAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import "./../../../Public/css/leads_list.css";


const Lead = () =>{

    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    //const [dispositions, setDispositions] = useState([]);
    //const [filterdisposition, setFilterDisposition] = useState(0);
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [totalrecords, setTotalRecords] = useState(0);
    const [isfilterpagination, setIsFilterPagination] = useState(false);

    const perpagedata = 20;


    useEffect(() => {

        LeadDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, "", setTotalRecords);

    }, [currentPage]);

    /*useEffect(() => {

        handleFilterLeads();

    }, [currentPage]);*/

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }

    const handleInputEmailFilter =(e) =>{

        setFilterEmail(e.target.value);
    }

    const handleInputNameFilter = (e) =>{
        setFilterName(e.target.value);
    }

    const handleFilterLeads = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);

        const filterparams = new URLSearchParams();

        if(filtername)
        {
            filterparams.append('filtername', filtername);
        }

        if(filteremail)
        {
            filterparams.append('filteremail', filteremail);
        }

        if(currentPage)
        {
            filterparams.append('page', currentPage);
        }

        if(perpagedata)
        {
            filterparams.append('per_page', perpagedata);
        }

        LeadDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filterparams, setTotalRecords);
    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Leads</h4>
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card crm-leads-filter-card">
                        <div className="card-body">
                            <div className="row crm-filter-row-top">
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Name</label>
                                    <input className="form-control" type="text" name="filtername" onChange={handleInputNameFilter} placeholder="Enter name" />
                                </div>

                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Email</label>
                                    <input className="form-control" type="email" name="filteremail" onChange={handleInputEmailFilter} placeholder="Enter email" />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label opacity-0">Actions</label>
                                    <div class="crm-filter-actions">
                                        <button type="button" className="btn btn-primary" onClick={handleFilterLeads}>
                                            <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                            <div className="mb-2">
                                <strong>Total Records:</strong> {totalrecords}
                            </div>

                            <div className="table-responsive table-wrapper">
                                {loading ?

                                    <ContentLoader />
                                :

                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>University/Institute</th>
                                            <th>Source</th>
                                            <th>Stage</th>
                                            <th>Remarks</th>
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {leads && leads.length > 0  ?
                                        leads.map(lead =>
                                        (

                                            <tr key={lead.id}>

                                                <td>
                                                    <Link to={`/publisher/lead-profile/${lead.id}`} className="">
                                                        {lead.name}
                                                    </Link>
                                                </td>
                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>{lead.source}</td>
                                                <td>{lead.stagename}</td>
                                                <td>{lead.remarks}</td>
                                                <td>
                                                    {lead.created_at !== "" && lead.created_at !== null && lead.created_at !== undefined ?

                                                        moment(lead.created_at).format('DD-MMM-YYYY h:mm')
                                                    :
                                                        <>-</>
                                                    }
                                                </td>

                                            </tr>
                                        ))

                                    :

                                        <tr>
                                            <td colSpan="10">
                                                <p>No record found...</p>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default Lead;
